var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`menu apps-menu ${_vm.addClass}`},[_c('div',{staticClass:"apps-menu-bgwrap",on:{"click":_vm.toggleMenu}},[_c('div',{staticClass:"apps-menu-container"},[_c('div',{staticClass:"apps-menu-card"},[_c('div',{staticClass:"apps-menu-apps"},[_c('AppsAvailable')],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }